import { twc } from "../utils";

const StatusRow = twc.div`flex items-center gap-2 text-sm text-text-secondary py-1 animate-fade-in`;

const STATUS_EMOJI: Record<string, string> = {
  thinking: "🤔",
  searching: "🔍",
  looking_up: "📖",
  reviewing: "📋",
  preparing: "✨",
  checking: "✅",
};

type Props = {
  status: string;
  context?: string;
};

export function StatusIndicator({ status, context }: Props) {
  const emoji = STATUS_EMOJI[status] || "⏳";
  const label = status.charAt(0).toUpperCase() + status.slice(1).replace("_", " ");
  const detail = context ? ` ${context}...` : "...";

  return (
    <StatusRow>
      <span className="animate-pulse">{emoji}</span>
      <span>{`${label}${detail}`}</span>
    </StatusRow>
  );
}
